import { Component } from '@angular/core';

import './../../node_modules/nouislider/distribute/nouislider.min.css';

declare var wNumb;

@Component({
  selector: 'pax-savings-slider',
  styles: [require('./savings-slider.component.sass')],
  template: require('./savings-slider.component.html')
})
export class SavingsSliderComponent {
  public initialValue: number = 40000;
  public minValue: number = 20000;
  public maxValue: number = 60000;
  public step: number = 500;
  public sliderValue: number = this.initialValue;
  public sagingsValue: number = 0;

  moneyFormat: any = wNumb({
    decimals: 0,
    thousand: ',',
    prefix: '$'
  });

  sliderConfig: any = {
    behaviour: 'drag',
    start: this.initialValue,
    step: this.step,
    tooltips: [this.moneyFormat],
    range: {
      'min': this.minValue,
      '50%': [this.initialValue, this.step],
      'max': this.maxValue
    },
    pips: {
      mode: 'positions',
      values: [0, 100],
      density: 100,
      format: this.moneyFormat
    }
  };

  constructor() {
    this.updateResult(this.initialValue);
  }

  updateResult(value) {
    // TODO: extract formula to service
    if (value <= 21000) {                         this.sagingsValue = this.moneyFormat.to(0.06 * value - 12 * 92);
    } else if (value > 21000 && value <= 30000) { this.sagingsValue = this.moneyFormat.to(0.0075 * value);
    } else if (value > 30000 && value <= 40000) { this.sagingsValue = this.moneyFormat.to(0.01 * value);
    } else if (value > 40000 && value <= 60000) { this.sagingsValue = this.moneyFormat.to(0.015 * value);
    } else if (value > 60000) {                   this.sagingsValue = this.moneyFormat.to(0.015 * value); }
    if (value < 0) {                              this.sagingsValue = this.moneyFormat.to(0); }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/savings-slider/savings-slider.component.ts